/*
* 揽收司机，揽收中页面路径枚举
* */
export enum PickingUpPath {
    // 揽收任务详情
    PICKUP_PICKINGUP_DETAIL = "/pickup/picking-up/detail/:appointmentId/:status",
    // 揽收失败
    PICKUP_FAILED = "/pickup/failed/:appointmentId/:failedReason",
    // 揽收地图模式
    PICKUP_PICKINGUP_MAP = "/pickup/picking-up/map",
    // 揽收列表
    PICKUP_PICKINGUP = "/pickup/picking-up",
}

/*
* 揽收司机，已完成任务页面路径枚举
* */
export enum PickupFinishedPath {
    // 已完成任务列表
    PICKUP_FINISHED = "/pickup/finished",
    // 已完成任务详情（起点、揽收成功、揽收失败、交接成功）
    PICKUP_FINISHED_DETAIL = "/pickup/finished/detail/:appointmentId/:taskId/:selectedDate",
}

/*
* 揽收司机，设置页面路径枚举
* */
export enum PickupSettingsPath {
    // 揽收设置
    PICKUP_SETTINGS = "/pickup/picking-up/settings",
    // 揽收语言设置
    PICKUP_SETTINGS_LANGUAGE = "/pickup/picking-up/settings/language",
    // 揽收默认导航地图设置
    PICKUP_SETTINGS_NAVIGATION_APP = "/pickup/picking-up/settings/navigation-app",
}